"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SuggestionBox = exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../utils/utils");

var _useOnClickOutside = require("../../hooks/useOnClickOutside");

var _useDebounce = require("../../hooks/useDebounce");

var variables = _interopRequireWildcard(require("../GridSystem/_vars_widths"));

var _colors = _interopRequireDefault(require("../../colors"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _TextField = _interopRequireDefault(require("../TextField/TextField"));

var _DropDownList = _interopRequireWildcard(require("./DropDownList.styled"));

var _excluded = ["automationId", "children", "disabled", "id", "errorMessage", "highlightMatch", "label", "ariaLabel", "items", "onChange", "onTextChange", "showClearIcon", "defaultValue", "selectedItem", "selectedValue", "dropDownStyle", "selectRef", "textBoxRef", "disableFilter"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ChevronDown = function ChevronDown(props) {
  return _react["default"].createElement("svg", props, _react["default"].createElement("title", null, "Chevron Arrow Down"), _react["default"].createElement("path", {
    fill: "#25292D",
    d: "M4.354 5.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 1 0-.708-.708L8 9.293 4.354 5.646z"
  }));
};

ChevronDown.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};

var CheckMark = function CheckMark(props) {
  return _react["default"].createElement("svg", props, _react["default"].createElement("title", null, "Checkmark Accept OK Okay"), _react["default"].createElement("path", {
    fill: "#25292D",
    d: "M5.354 7.81a.5.5 0 1 0-.708.708l1.786 1.786a.5.5 0 0 0 .708 0l4.449-4.45a.501.501 0 1 0-.709-.708L6.786 9.243 5.354 7.81z"
  }));
};

CheckMark.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};

var Cross = function Cross(props) {
  return _react["default"].createElement("svg", props, _react["default"].createElement("title", null, "X Remove Delete Close Cross Multiply"), _react["default"].createElement("path", {
    fill: "#25292D",
    d: "M5.147 5.146a.5.5 0 0 1 .707 0l2.13 2.131 2.131-2.13a.5.5 0 0 1 .638-.058l.07.057a.5.5 0 0 1 0 .708L8.69 7.984l2.132 2.131a.5.5 0 0 1 .058.638l-.058.07a.5.5 0 0 1-.707 0L7.984 8.69l-2.13 2.133a.5.5 0 0 1-.638.057l-.07-.057a.5.5 0 0 1 0-.708l2.131-2.131-2.13-2.13a.5.5 0 0 1-.058-.638z"
  }));
};

Cross.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};

var DropDownList = function DropDownList(_ref, RENDER_AS_SUGGESTION_BOX) {
  var _ref$automationId = _ref.automationId,
      automationId = _ref$automationId === void 0 ? "" : _ref$automationId,
      children = _ref.children,
      disabled = _ref.disabled,
      id = _ref.id,
      errorMessage = _ref.errorMessage,
      _ref$highlightMatch = _ref.highlightMatch,
      highlightMatch = _ref$highlightMatch === void 0 ? false : _ref$highlightMatch,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "" : _ref$label,
      ariaLabel = _ref.ariaLabel,
      items = _ref.items,
      onChange = _ref.onChange,
      onTextChange = _ref.onTextChange,
      _ref$showClearIcon = _ref.showClearIcon,
      showClearIcon = _ref$showClearIcon === void 0 ? false : _ref$showClearIcon,
      defaultValue = _ref.defaultValue,
      selectedItem = _ref.selectedItem,
      selectedValue = _ref.selectedValue,
      _ref$dropDownStyle = _ref.dropDownStyle,
      dropDownStyle = _ref$dropDownStyle === void 0 ? "primary" : _ref$dropDownStyle,
      selectRef = _ref.selectRef,
      textBoxRef = _ref.textBoxRef,
      _ref$disableFilter = _ref.disableFilter,
      disableFilter = _ref$disableFilter === void 0 ? false : _ref$disableFilter,
      props = _objectWithoutProperties(_ref, _excluded);

  var getItemByValue = function getItemByValue(items, value) {
    if (!items || value === undefined || value === null) {
      return null;
    }

    return items.filter(function (item) {
      return (0, _utils.getComponentItemValue)(item) == value;
    })[0];
  };

  var _useState = (0, _react.useState)(items),
      _useState2 = _slicedToArray(_useState, 2),
      currentItems = _useState2[0],
      setCurrentItems = _useState2[1];

  var _useState3 = (0, _react.useState)(defaultValue || selectedValue),
      _useState4 = _slicedToArray(_useState3, 2),
      currentSelectedValue = _useState4[0],
      setCurrentSelectedValue = _useState4[1];

  var defaultSelectedItem = selectedItem || getItemByValue(items, currentSelectedValue);

  var _useState5 = (0, _react.useState)(selectedItem || defaultSelectedItem),
      _useState6 = _slicedToArray(_useState5, 2),
      currentSelectedItem = _useState6[0],
      setCurrentSelectedItem = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      focusedItem = _useState8[0],
      setFocusedItem = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      opened = _useState10[0],
      setOpened = _useState10[1];

  var _useState11 = (0, _react.useState)(defaultSelectedItem ? defaultSelectedItem.text || defaultSelectedItem : ""),
      _useState12 = _slicedToArray(_useState11, 2),
      suggestedText = _useState12[0],
      setSuggestedText = _useState12[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = _slicedToArray(_useState13, 2),
      unlockScroll = _useState14[0],
      setUnlockScroll = _useState14[1];

  var clickableAreaRef = (0, _react.useRef)();
  var menuDisplayRef = (0, _react.useRef)();
  var hardTextBoxref = (0, _react.useRef)();
  var hardSelectRef = (0, _react.useRef)();
  var internalTextBoxRef = textBoxRef || hardTextBoxref;
  var internalSelectRef = selectRef || hardSelectRef;
  var useFilter = !disableFilter;
  var mouseWheelEventAttached = false;
  (0, _react.useEffect)(function () {
    if (internalSelectRef.current) {
      var newSelectedItem = getItemByValue(items, currentSelectedValue);
      updateSuggestedText(newSelectedItem);

      if (newSelectedItem) {
        setCurrentSelectedItem(newSelectedItem);
      }

      setCurrentItems(items);
    } //eslint-disable-next-line

  }, [items]);
  (0, _react.useEffect)(function () {
    if (selectedItem) {
      updateSuggestedText(selectedItem);
      setCurrentSelectedItem(selectedItem);
      setCurrentSelectedValue((0, _utils.getComponentItemValue)(selectedItem));
    } //eslint-disable-next-line

  }, [selectedItem]);
  (0, _react.useEffect)(function () {
    var newSelectedItem = getItemByValue(currentItems, selectedValue);

    if (newSelectedItem) {
      updateSuggestedText(newSelectedItem);
      setCurrentSelectedItem(newSelectedItem);
      setCurrentSelectedValue((0, _utils.getComponentItemValue)(newSelectedItem));
    } //eslint-disable-next-line

  }, [selectedValue]);
  (0, _react.useEffect)(function () {
    if ((0, _utils.isMobile)(variables.desktop_breakpoint) && RENDER_AS_SUGGESTION_BOX !== true && opened && !(0, _utils.scrollLocked)()) {
      (0, _utils.scrollLock)();
      setUnlockScroll(true);
    } else if (unlockScroll) {
      (0, _utils.scrollUnlock)();
      setUnlockScroll(false);
    }
  }, [opened]);
  (0, _react.useEffect)(function () {
    attachMouseWheelEvent();

    if (!automationId) {
      console.warn("Automation id was not provided.");
    }

    return function () {
      document.removeEventListener("mousedown", handleDocumentClick);
    }; //eslint-disable-next-line
  }, []);

  var suppressScrolling = function suppressScrolling(e) {
    var menuDisplay = menuDisplayRef.current;

    if (menuDisplay) {
      if (e.target === menuDisplay || menuDisplay.contains(e.target)) {
        if (e.wheelDelta > 0 && menuDisplay.scrollTop <= 0) {
          e.preventDefault();
        } else if (e.wheelDelta < 0 && menuDisplay.scrollTop + menuDisplay.offsetHeight >= menuDisplay.scrollHeight) {
          e.preventDefault();
        }
      }
    }
  };

  var attachMouseWheelEvent = function attachMouseWheelEvent() {
    var menuDisplay = menuDisplayRef.current;

    if (menuDisplay && !mouseWheelEventAttached) {
      // so this is to make sure the event gets attached, we can't use "onWheel" event from react because it's a passive event, we need the event
      // to remain active and have to manually attach the event
      menuDisplay.addEventListener("mousewheel", suppressScrolling, {
        passive: false
      });
      mouseWheelEventAttached = true;
    } else {
      setTimeout(attachMouseWheelEvent, 1000);
    }
  };

  var handleDocumentClick = function handleDocumentClick(e) {
    var clickableArea = clickableAreaRef.current;

    if (!clickableArea || e.target !== clickableArea && !clickableArea.contains(e.target)) {
      setOpened(false);
    }
  };

  if (typeof document !== "undefined") {
    //eslint-disable-next-line
    (0, _useOnClickOutside.useOnClickOutside)(clickableAreaRef, handleDocumentClick);
  }

  var handleKeyDown = function handleKeyDown(e) {
    // this handles the keyboard functionality for the drop down menu
    var menuDisplay = menuDisplayRef.current;
    var nextItemIndex = currentItems.indexOf(getItemByValue(currentItems, (0, _utils.getComponentItemValue)(currentSelectedItem)));

    if (menuDisplay) {
      if (e.keyCode === 38 || e.keyCode === 40) {
        if (e.keyCode === 40) {
          // down arrow
          nextItemIndex++;
        } else if (e.keyCode === 38) {
          // up arrow
          nextItemIndex--;
        }

        if (nextItemIndex >= currentItems.length) {
          nextItemIndex = 0;
        }

        if (nextItemIndex < 0) {
          nextItemIndex = currentItems.length - 1;
        }

        var nextItem = currentItems[nextItemIndex];
        var focusedMenuItem = menuDisplay.children[nextItemIndex];

        if (nextItem === currentSelectedItem) {
          return;
        } // if the menu item to focus on is out of view, scroll to bring it into view


        if (focusedMenuItem.offsetTop >= menuDisplay.scrollTop + menuDisplay.clientHeight || focusedMenuItem.offsetTop <= menuDisplay.scrollTop) {
          menuDisplay.scrollTop = focusedMenuItem.offsetTop;
        }

        if (opened) {
          setFocusedItem(focusedMenuItem);
        }

        setCurrentSelectedItem(nextItem);

        if (onChange && RENDER_AS_SUGGESTION_BOX !== true) {
          onChange(nextItem.__hiddenObject || nextItem);
        }

        e.preventDefault();
        e.stopPropagation();
      } else if (e.keyCode === 13) {
        // enter key
        // this closes the dropdown menu to confirm the user's highlighted selection
        if (focusedItem) {
          setFocusedItem(null);
          setOpened(false);
          updateSuggestedText(currentSelectedItem);

          if (RENDER_AS_SUGGESTION_BOX === true) {
            onChange(currentSelectedItem.__hiddenObject || currentSelectedItem);
          }

          e.preventDefault();
          e.stopPropagation();
        }
      } else if (e.keyCode === 9) {
        // tab
        // this ensures the dropdown menu closes when the user tabs off the dropdown
        setOpened(false);
      }
    }
  };

  var handleItemClick = function handleItemClick(e, item) {
    // if a selection is clicked and there's a textbox, then make sure it's focused
    if (internalTextBoxRef.current) {
      internalTextBoxRef.current.focus();
    }

    setFocusedItem(null);
    setOpened(false);
    setCurrentSelectedItem(item);
    updateSuggestedText(item);

    if (onChange) {
      onChange(item.__hiddenObject || item);
    }

    e.stopPropagation();
  };

  var updateSuggestedText = function updateSuggestedText(item) {
    if (item === undefined || item === null) {
      return setSuggestedText(suggestedText);
    }

    if (props.itemTextDisplay === "value") {
      return setSuggestedText(item.value || item);
    }

    return setSuggestedText(item.text || item);
  };

  var dropDownRender = function dropDownRender(renderedItems) {
    // create the menu that will display in the dropdown list, if there are no items, render nothing
    var renderedMenu = renderedItems && renderedItems.length > 0 ? _react["default"].createElement("menu", {
      className: "dropdown-display",
      ref: menuDisplayRef
    }, renderedItems.map(function (item, index) {
      return _react["default"].createElement("li", {
        className: (0, _utils.componentItemsEqual)(item, currentSelectedItem) ? "selected" : "",
        key: "".concat(id || "", "-").concat(index),
        onMouseDown: function onMouseDown(e) {
          return handleItemClick(e, item);
        }
      }, item.__renderedComponent || item.text || item, _react["default"].createElement(_Icon["default"], {
        color: _colors["default"].primary.claytonBlue.standard
      }, _react["default"].createElement(CheckMark, null)));
    })) : null;
    return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("select", {
      "aria-label": ariaLabel || label,
      onChange: function onChange() {
        /* this is here to kill a warning */
      },
      value: (0, _utils.getComponentItemValue)(currentSelectedItem) || (internalTextBoxRef.current ? internalTextBoxRef.current.value : ""),
      id: id || "",
      ref: internalSelectRef,
      key: (id || "") + "-select",
      name: id || ""
    }, _react["default"].createElement("option", {
      key: "".concat(id || "", "-novalue"),
      value: ""
    }), renderedItems && renderedItems.length > 0 ? renderedItems.map(function (item, index) {
      return _react["default"].createElement("option", {
        key: "".concat(id || "", "-").concat(index),
        value: (0, _utils.getComponentItemValue)(item)
      }, item.text || item);
    }) : defaultValue ? _react["default"].createElement("option", {
      value: defaultValue
    }, defaultValue) : internalTextBoxRef.current ? _react["default"].createElement("option", {
      value: internalTextBoxRef.current.value
    }, internalTextBoxRef.current.value) : null), showClearIcon && suggestedText ? _react["default"].createElement(_Icon["default"], {
      className: "suggestion-clear",
      color: _colors["default"].accent.grey1.standard,
      onClick: function onClick(e) {
        setCurrentSelectedItem(null);
        setCurrentItems(items);
        updateSuggestedText("");
        internalTextBoxRef.current.focus();
        e.preventDefault();
        e.stopPropagation();
      }
    }, _react["default"].createElement(Cross, null)) : _react["default"].createElement(_Icon["default"], {
      color: _colors["default"].accent.grey1.standard,
      className: "dropdown-chevron",
      onClick: function onClick(e) {
        setOpened(!opened);

        if (internalTextBoxRef.current) {
          internalTextBoxRef.current.focus();
        }

        e.preventDefault();
        e.stopPropagation();
      }
    }, _react["default"].createElement(ChevronDown, null)), renderedMenu || children ? _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("div", {
      className: "dropdown-menu",
      onClick: function onClick(e) {
        setOpened(false);
        e.preventDefault();
        e.stopPropagation();
      }
    }, _react["default"].createElement("div", {
      className: "dropdown-close"
    }, _react["default"].createElement(_Icon["default"], {
      color: _colors["default"].primary.white.standard
    }, _react["default"].createElement(Cross, null))), renderedMenu || _react["default"].createElement("div", {
      className: "dropdown-display"
    }, children)), _react["default"].createElement("div", {
      onClick: function onClick(e) {
        setOpened(false);
        e.preventDefault();
        e.stopPropagation();
      },
      className: "dropdown-filter"
    })) : null);
  };

  var classes = [];

  if (props.className) {
    classes.push(props.className);
  }

  if (errorMessage) {
    classes.push('error');
  }

  if (opened) {
    classes.push('open');
  }

  if (disabled) {
    classes.push('disabled');
  }

  if (dropDownStyle.toLowerCase().trim() === 'primary-background') {
    classes.push('has-background');
    dropDownStyle = 'primary';
  }

  if (dropDownStyle.toLowerCase().trim() === 'compact') {
    classes.push('compact');
  }

  if (dropDownStyle.toLowerCase().trim() === 'outlined') {
    classes.push('outlined');
  }

  if (RENDER_AS_SUGGESTION_BOX !== true) {
    return _react["default"].createElement(_DropDownList["default"], _extends({
      id: (id || "") + "-container",
      ref: clickableAreaRef,
      key: id
    }, props, {
      className: "dropdown-list " + classes.join(' ')
    }), _react["default"].createElement("button", {
      id: (id || "") + "-button",
      className: currentSelectedItem ? " has-value" : "",
      onClick: function onClick() {
        return setOpened(!opened);
      },
      onKeyDown: handleKeyDown,
      disabled: disabled,
      type: "button"
    }, _react["default"].createElement("label", null, label), _react["default"].createElement("span", {
      className: "dropdown-selected-text"
    }, currentSelectedItem ? currentSelectedItem.text || currentSelectedItem : internalSelectRef.current ? internalSelectRef.current.queryValue || " " : " ")), errorMessage ? _react["default"].createElement("span", {
      className: "error-message"
    }, errorMessage) : null, dropDownRender(currentItems));
  } //*********************************************************
  //                 SUGGESTION BOX ONLY
  //VVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV
  // these functions are specific for the SuggestionBox


  if (RENDER_AS_SUGGESTION_BOX) {
    //eslint-disable-next-line
    var _useState15 = (0, _react.useState)(false),
        _useState16 = _slicedToArray(_useState15, 2),
        runFilter = _useState16[0],
        setRunFilter = _useState16[1];

    var filterItems = function filterItems(text) {
      if (!text) {
        return items || [];
      } // filter out items that match the typed in text


      var returnItems = items ? items.filter(function (item) {
        var itemText = (item.text || item).toLowerCase();

        if (itemText) {
          return itemText.indexOf(text) > -1;
        }

        return false;
      }) : []; // if highlightMatch is true, then we returned a new set of objects that contain things to allow a highlighted version of the
      // text to display,  the render looks for a __renderedComponent first, then the text property and finally the item itself
      // so we simply utilize that __renderedComponent property

      if (highlightMatch) {
        return returnItems.map(function (item, index) {
          var itemText = item.text || item;
          var textIndex = itemText.toLowerCase().indexOf(text);
          return {
            text: item.text || item,
            value: (0, _utils.getComponentItemValue)(item),
            __hiddenObject: item,
            // this is here so we can pass the right object during the onItemSelected event
            __renderedComponent: [itemText.substring(0, textIndex), // if an item has a __renderedComponent, this will be used instead of the text
            _react["default"].createElement("span", {
              key: id + "-highlight-" + index,
              className: "highlight"
            }, itemText.substring(textIndex, textIndex + text.length)), itemText.substring(textIndex + text.length)]
          };
        });
      }

      return returnItems;
    }; //eslint-disable-next-line


    var handleKeyUp = (0, _useDebounce.useDebounce)(internalTextBoxRef, function (e) {
      if (runFilter) {
        var filteredItems = filterItems((suggestedText || "").toLowerCase());
        setCurrentItems(filteredItems);
        setOpened(true);
        setRunFilter(false);
        setCurrentSelectedItem(filteredItems.filter(function (item) {
          return internalTextBoxRef.current.value.toLowerCase() === (item.text !== undefined ? item.text : item).toLowerCase();
        })[0]);
      }
    }, 200);

    var getTextDisplay = function getTextDisplay() {
      return suggestedText || internalSelectRef.current && internalSelectRef.current.queryValue || "";
    };

    return _react["default"].createElement(_DropDownList.SuggestionBoxStyles, _extends({}, props, {
      className: "suggestion-box dropdown-list " + classes.join(' '),
      onClick: function onClick() {
        internalTextBoxRef.current.focus();
      },
      id: id + "-container",
      ref: clickableAreaRef
    }), _react["default"].createElement(_TextField["default"], {
      disabled: disabled,
      errorMessage: errorMessage,
      id: id + "-text",
      autoComplete: "off",
      name: id + "-text",
      key: id || "",
      onChange: function onChange(e) {
        updateSuggestedText(e.target.value);
        setRunFilter(useFilter);

        if (onTextChange) {
          onTextChange(e);
        }
      },
      label: label,
      onClick: function onClick() {
        return setOpened(true);
      },
      onFocus: function onFocus() {
        return setOpened(true);
      },
      onKeyDown: handleKeyDown,
      onKeyUp: handleKeyUp,
      className: "dropdown-textbox " + (suggestedText ? 'has-value' : ''),
      ref: internalTextBoxRef,
      textFieldStyle: dropDownStyle,
      value: getTextDisplay()
    }), dropDownRender(currentItems));
  } //^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
  //                 SUGGESTION BOX ONLY
  //**********************************************************
  // these functions are specific for the SuggestionBox

};

DropDownList.defaultProps = {
  automationId: "",
  disabled: false,
  id: false,
  errorMessage: "",
  label: "",
  items: [],
  onChange: null,
  showClearIcon: false,
  defaultValue: "",
  selectedItem: null,
  selectedValue: "",
  dropDownStyle: "primary",
  text: null
};
DropDownList.props = {
  automationId: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  id: _propTypes["default"].string,
  errorMessage: _propTypes["default"].string,
  label: _propTypes["default"].string,
  items: _propTypes["default"].array,
  onChange: _propTypes["default"].func,
  showClearIcon: false,
  defaultValue: _propTypes["default"].string,
  selectedItem: _propTypes["default"].object,
  selectedValue: _propTypes["default"].string,
  dropDownStyle: _propTypes["default"].oneOf(["primary", "primary-background", "outline", "compact"]),
  text: null
};
var _default = DropDownList;
exports["default"] = _default;

var SuggestionBox = function SuggestionBox(_ref2) {
  var props = _extends({}, _ref2);

  return DropDownList(_objectSpread(_objectSpread({}, props), {}, {
    showClearIcon: true
  }), true);
};

exports.SuggestionBox = SuggestionBox;
SuggestionBox.defaultProps = {
  automationId: "",
  disabled: false,
  id: "",
  errorMessage: "",
  highlightMatch: false,
  label: "",
  items: [],
  onChange: null,
  showClearIcon: false,
  defaultValue: "",
  selectedItem: null,
  selectedValue: "",
  onTextChange: null,
  itemTextDisplay: "",
  dropDownStyle: "primary",
  disableFilter: false
};
SuggestionBox.props = {
  automationId: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  id: _propTypes["default"].string,
  errorMessage: _propTypes["default"].string,
  highlightMatch: false,
  label: _propTypes["default"].string,
  ariaLabel: _propTypes["default"].string,
  items: _propTypes["default"].array,
  onChange: _propTypes["default"].func,
  showClearIcon: false,
  defaultValue: _propTypes["default"].string,
  selectedItem: _propTypes["default"].object,
  selectedValue: _propTypes["default"].string,
  onTextChange: _propTypes["default"].func,
  itemTextDisplay: _propTypes["default"].oneOf(["", "text", "value"]),
  dropDownStyle: _propTypes["default"].oneOf(["primary", "primary-background", "outline", "compact"]),
  disableFilter: false
};